var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackClock01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9133 12.8237C13.4372 12.9983 14.0035 12.7152 14.1782 12.1912C14.3528 11.6673 14.0697 11.101 13.5457 10.9263L12.9133 12.8237ZM10.417 10.9375H9.41699C9.41699 11.3679 9.69242 11.7501 10.1008 11.8862L10.417 10.9375ZM11.417 7.01739C11.417 6.46511 10.9693 6.01739 10.417 6.01739C9.86471 6.01739 9.41699 6.46511 9.41699 7.01739H11.417ZM13.5457 10.9263L10.7332 9.98882L10.1008 11.8862L12.9133 12.8237L13.5457 10.9263ZM11.417 10.9375V7.01739H9.41699V10.9375H11.417ZM16.917 10C16.917 13.5899 14.0068 16.5 10.417 16.5V18.5C15.1114 18.5 18.917 14.6944 18.917 10H16.917ZM10.417 16.5C6.82714 16.5 3.91699 13.5899 3.91699 10H1.91699C1.91699 14.6944 5.72257 18.5 10.417 18.5V16.5ZM3.91699 10C3.91699 6.41015 6.82714 3.5 10.417 3.5V1.5C5.72257 1.5 1.91699 5.30558 1.91699 10H3.91699ZM10.417 3.5C14.0068 3.5 16.917 6.41015 16.917 10H18.917C18.917 5.30558 15.1114 1.5 10.417 1.5V3.5Z",
    fill: "#172A47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClock01);
export default __webpack_public_path__ + "static/media/black-clock-01.c13309e75a1b74264823b6aeed3eca51.svg";
export { ForwardRef as ReactComponent };